import React from 'react';
import Card from '../../ui/Card';
import DescriptionPanel from '../../ui/DescriptionPanel';
import { TrendingUpIcon, TrendingDownIcon } from 'lucide-react';
import RevenueMapChart from './RevenueMapChart';
import RevenueLineChart from './RevenueLineChart';
import CustomerBarChart from './CustomerBarChart';
import PipelineFunnelChart from './PipelineFunnelChart';
import CustomerTable from './CustomerTable';
import CapacityGauge from './CapacityGauge';
import OrderBookTracker from './OrderBookTracker';
import WarningFlags from './WarningFlags';
const SalesDashboard: React.FC = () => {
  const salesKPIs = [{
    title: 'Total Revenue',
    value: '₹9,250 Cr',
    change: '+5.2%',
    isPositive: true
  }, {
    title: 'Revenue YoY Growth',
    value: '12.4%',
    change: '+2.1%',
    isPositive: true
  }, {
    title: 'OEM vs Aftermarket',
    value: '68:32',
    change: 'Stable',
    isPositive: true
  }, {
    title: 'Top Customer Share',
    value: '18.5%',
    change: '-1.2%',
    isPositive: true
  }, {
    title: 'Avg Margin',
    value: '14.8%',
    change: '+0.7%',
    isPositive: true
  }];
  return <div data-id="element-9075">
      <DescriptionPanel title="Sales Performance Overview" description="Comprehensive analysis of revenue streams, customer concentration, and sales pipeline across all regions and product lines. This dashboard provides real-time visibility into sales performance, capacity utilization, and early warning indicators to drive strategic decision-making." insights={['West region leading with ₹3,200 Cr revenue (34.6% of total)', 'New business pipeline at ₹4,850 Cr with 19% conversion to SOP', 'Plant capacity utilization at 78% - headroom for growth', 'Top 3 customers contribute 47.7% of revenue - diversification opportunity']} data-id="element-9076" />
      {/* Sales KPI Row */}
      <div className="mb-8" data-id="element-9077">
        <h2 className="text-xl font-bold text-gray-900 mb-6" data-id="element-9078">
          Sales Performance Metrics
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6" data-id="element-9079">
          {salesKPIs.map((kpi, index) => <Card key={index} className="p-5 bg-gradient-to-br from-white to-gray-50" data-id="element-9080">
              <div className="flex flex-col h-full" data-id="element-9081">
                <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide" data-id="element-9082">
                  {kpi.title}
                </div>
                <div className="mt-3 text-3xl font-bold text-gray-900" data-id="element-9083">
                  {kpi.value}
                </div>
                <div className={`mt-2 text-sm flex items-center font-semibold ${kpi.isPositive ? 'text-green-600' : 'text-red-600'}`} data-id="element-9084">
                  {kpi.change !== 'Stable' && <>
                      {kpi.isPositive ? <TrendingUpIcon size={16} className="mr-1" data-id="element-9085" /> : <TrendingDownIcon size={16} className="mr-1" data-id="element-9086" />}
                    </>}
                  {kpi.change}
                </div>
              </div>
            </Card>)}
        </div>
      </div>
      {/* Advanced Widgets Row */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-8" data-id="element-9087">
        <CapacityGauge data-id="element-9088" />
        <OrderBookTracker data-id="element-9089" />
        <WarningFlags data-id="element-9090" />
      </div>
      {/* Main Charts Row 1 */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8" data-id="element-9091">
        <RevenueMapChart data-id="element-9092" />
        <RevenueLineChart data-id="element-9093" />
      </div>
      {/* Main Charts Row 2 */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8" data-id="element-9094">
        <CustomerBarChart data-id="element-9095" />
        <PipelineFunnelChart data-id="element-9096" />
      </div>
      {/* Customer Concentration Table */}
      <CustomerTable data-id="element-9097" />
    </div>;
};
export default SalesDashboard;